<template>
    <div class="content content-page bookmark">
        <div class="container">
            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-8">
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <div class="page-title portfolio-title justify-content-center">
                            <h3 class="mb-0">Accesos al Sistema</h3>
                        </div>
                        <div>
                            <form @submit.prevent="updateSystemAccess">
                                <div class="container">
<!--                                    <div class="row align-items-center">-->
<!--                                        <div class="col-md-4"></div>-->
<!--                                        <div class="col-md-4 col-lg-4">-->
<!--                                            <div class="input-block">-->
<!--                                                <label class="focus-label">Nombre de Usuario</label>-->
<!--                                                <input type="text" name="education['university_name'][]" class="form-control" v-model="username" disabled/>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->

                                    <div class="row align-items-center">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4 col-lg-4">
                                            <div class="input-block">
                                            <label class="focus-label">Correo Electrónico</label>
                                            <input type="text" name="education['university_name'][]" class="form-control" v-model="email" disabled/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4 col-lg-4">
                                            <div class="input-block">
                                            <label class="focus-label">Contraseña Actual <span class="label-star"> *</span></label>
                                            <div class="position-relative">
                                                <Field
                                                name="password"
                                                :type="showPassword ? 'text' : 'password'"
                                                class="form-control pass-input mt-2"
                                                v-model="password_old"
                                                />
                                                <!-- :class="{ 'is-invalid': errors.password }" -->
                                                <span @click="toggleShow" class="toggle-password2">
                                                <i
                                                    :class="{
                                                    'fas fa-eye': showPassword,
                                                    'fas fa-eye-slash': !showPassword,
                                                    }"
                                                ></i>
                                                </span>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4 col-lg-4">
                                            <div class="input-block">
                                                <label class="focus-label">Nueva Contraseña <span class="label-star"> *</span></label>
                                                <div class="position-relative">
                                                    <Field
                                                    name="password"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    class="form-control pass-input mt-2"
                                                    v-model="password"
                                                    />
                                                    <!-- :class="{ 'is-invalid': errors.password }" -->
                                                    <span @click="toggleShow" class="toggle-password2">
                                                    <i
                                                        :class="{
                                                        'fas fa-eye': showPassword,
                                                        'fas fa-eye-slash': !showPassword,
                                                        }"
                                                    ></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4 col-lg-4">
                                            <div class="input-block">
                                                <label class="focus-label">Confirmar Nueva Contraseña <span class="label-star"> *</span></label>
                                                <div class="position-relative">
                                                    <Field
                                                    name="password"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    class="form-control pass-input mt-2"
                                                    v-model="password_confirm"
                                                    />
                                                    <!-- :class="{ 'is-invalid': errors.password }" -->
                                                    <span @click="toggleShow" class="toggle-password2">
                                                    <i
                                                        :class="{
                                                        'fas fa-eye': showPassword,
                                                        'fas fa-eye-slash': !showPassword,
                                                        }"
                                                    ></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4">
                                            <button class="btn btn-primary pt-1" type="submit" style="width:100%; padding-top:30px; padding-bottom:10px;">Actualizar Datos</button>
                                        </div>
                                    </div>
                                    <!-- <input class="btn btn-primary btn-get btn-next" name="next" type="submit" value="Actualizar Datos "> -->
                                </div>
                            </form>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
import { Form, Field } from "vee-validate";

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
        id_applicant: JSON.parse(localStorage.getItem('userData'))?.id_usuario,

        showPassword: false,
        password: null,
        password_confirm:null,
        password_old:null,
        password_old_bd:null,
        emailError: "",
        passwordError: "",
        currentStep: 1,
        totalSteps: 4,
        
        username: null,
        email: null,
        password: null,

        name: null,
        firstSurname: null,
        secondSurname: null,
        selectedTypeDoc: null,
        typeDocs: ["C.E.","DNI","PASAPORTE"],
        n_doc: null,
        phone: null,
        birthdate: null,
        selectedGender: null,
        genders: ["Masculino","Femenino"],
        selectedMaritalStatus : null,
        maritalStatus : ["Soltero","Casado","Divorciado","Conviviente"],
        nationality: null,
        country: null,
        departament: null,
        province: null,
        district: null,
        salary_expect: null,
        personalDescription: null,
        availabTravel: 'NO',
        availabChangeResid: 'NO',
        driversLicense: 'NO',
        disability: 'NO',

        schoolCompleted: null,

    };
  },
  mounted(){
    this.getApplicant()
  },
  methods: {
    toggleShow() {
        this.showPassword = !this.showPassword;
    },

    getApplicant(){

        const yo = this
        const data = JSON.stringify({
            id : yo.id_applicant,
        })

        const config = {
            method: 'post',
            url: '/talentoagv/getApplicant/',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
        }

        axiosIns(config)
            .then(function (response) {
                console.log(response)
                if (response.data['is_error'] === false){
                    let datosUsuario = response.data['result'][0]
                    yo.username = datosUsuario['username']
                    yo.email = datosUsuario['email']
                    yo.password_old_bd= datosUsuario['password']
                }
        })
        .catch(function (error) {
            console.log(error);
            // yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })

    },

    updateSystemAccess(){

        const yo = this
        if(yo.password_old == yo.password_old_bd){
            console.log(yo.password)
            console.log(yo.password_confirm)
            if(yo.password == yo.password_confirm){
                const data = JSON.stringify({
                    id: yo.id_applicant,
                    password : yo.password_confirm,
                    block : 'access',
                })
    
                const config = {
                    method: 'post',
                    url: '/talentoagv/updateApplicant/',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data,
                }

                axiosIns(config)
                    .then(function (response) {
                        // if (response.data['is_error'] === false){
                        //     yo.$toastr.success('Usuario actualizado', 'Exito')
                        // }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function (){
                
                })

            }else{
                yo.$toastr.error('Las contraseñas no coinciden', 'Error')
            }
        }else{
            yo.$toastr.error('La antigua contraseña no es correcto', 'Error')
        }
    },
  }
}
</script>
